import { Injectable } from '@angular/core';
import { createFrom, EventService, ProductSearchService } from '@spartacus/core';
import { map, skip, switchMap } from 'rxjs/operators';
import { NavigationEvent } from '@spartacus/storefront';
import { EMPTY } from 'rxjs';
import { FbqGgCategoryPageEvent } from './fbq-gg-category-page-event';

@Injectable({
  providedIn: 'root',
})
export class FbqGgCategoryPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productSearchService: ProductSearchService
  ) {
    const searchResults$ = this.productSearchService.getResults().pipe(skip(1));

    const eventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute !== 'category') {
          return EMPTY;
        }

        return searchResults$.pipe(
          map(() =>
            createFrom(FbqGgCategoryPageEvent, {
              event: 'ViewContent',
            })
          )
        );
      })
    );

    eventService.register(FbqGgCategoryPageEvent, eventSource);
  }
}
